var path = '/templates/zenclerk_s/sites/campaigns/edit/instruction_shopserve.html';
var html = "<span translate=sites.campaigns.edit.instruction.shopserve></span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/sites/campaigns/edit/instruction_shopserve.html
// module id = 1396
// module chunks = 0